/**
 * Appends the selected entity-owner groups to a path as the `teams` query
 * parameter so the linked detail page opens with the same owner filter applied
 * (shareable via the link). Descendant subgroups are expanded by the detail
 * page itself, so only the explicitly selected owners are carried here.
 */
export const withTeamsParam = (path: string, teamRefs: string[]): string => {
  if (teamRefs.length === 0) {
    return path;
  }
  const teams = teamRefs.map(encodeURIComponent).join(',');
  const separator = path.includes('?') ? '&' : '?';
  return `${path}${separator}teams=${teams}`;
};
